/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_TitleInputs */

const en_signup_title = /** @type {(inputs: Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up for Closed Caption Creator`)
};

const fr_signup_title = /** @type {(inputs: Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrivez-vous à Closed Caption Creator`)
};

const de_signup_title = /** @type {(inputs: Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrieren Sie sich für den Untertitel-Generator`)
};

const it_signup_title = /** @type {(inputs: Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscriviti a Closed Caption Creator`)
};

const ru_signup_title = /** @type {(inputs: Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зарегистрируйтесь в программе для создания субтитров.`)
};

const es_signup_title = /** @type {(inputs: Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regístrate en Closed Caption Creator`)
};

const zh_cn2_signup_title = /** @type {(inputs: Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册使用字幕创建器`)
};

const ja_signup_title = /** @type {(inputs: Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クローズドキャプションクリエイターに登録する`)
};

const hi_signup_title = /** @type {(inputs: Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लोज्ड कैप्शन क्रिएटर के लिए साइन अप करें`)
};

const pt_pt2_signup_title = /** @type {(inputs: Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscreva-se no Criador de Legendas Ocultas`)
};

/**
* | output |
* | --- |
* | "Sign up for Closed Caption Creator" |
*
* @param {Signup_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_title = /** @type {((inputs?: Signup_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_title(inputs)
	if (locale === "de") return de_signup_title(inputs)
	if (locale === "it") return it_signup_title(inputs)
	if (locale === "ru") return ru_signup_title(inputs)
	if (locale === "es") return es_signup_title(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_title(inputs)
	if (locale === "ja") return ja_signup_title(inputs)
	if (locale === "hi") return hi_signup_title(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_title(inputs)
	return en_signup_title(inputs)
});